import compileGeneralAdmissionPolygon from './compileGeneralAdmissionPolygon';
import compileGeneralAdmissionLabel from './compileGeneralAdmissionLabel';
import compileGeneralAdmissionCacheKey from './compileGeneralAdmissionCacheKey';

function compileGeneralAdmission(generalAdmission) {
    let compiledGeneralAdmission = generalAdmission;

    compiledGeneralAdmission = compileGeneralAdmissionPolygon(compiledGeneralAdmission);
    compiledGeneralAdmission = compileGeneralAdmissionLabel(compiledGeneralAdmission);
    compiledGeneralAdmission = compileGeneralAdmissionCacheKey(compiledGeneralAdmission);

    return compiledGeneralAdmission;
}

export default compileGeneralAdmission;
